import { Box, Stack, styled } from "@mui/material";
import { customColors } from "models/customColors";

export const InfoSection = styled(Stack)`
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  column-gap: 2rem;
  row-gap: 0.5rem;
  
  padding: 14px 20px;
  
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 112.5% */
  border-radius: 13px;
  background: #f8f9fb;

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    padding: 10px 20px;
    font-size: 12px;
  }
`;

export const Paper = styled(Stack)`
  flex-direction: row;
  gap: 23px;
  
  padding: 23px;
  width: 100%;

  border-radius: 13px;
  border: 1px solid #dfdfdf;
  background-color: ${customColors.white};

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
    flex-direction: column;
  }
`;

export {
  Properties,
  Property,
  Label,
  ListHolder,
  Title,
  Info,
} from "./RecipientDetails.style";

export const SpecialistItem = styled(Box)`
  cursor: pointer;

  &:hover {
    background-color: lightgray;
  }
`;
